module.exports = __webpack_public_path__ + "img/lg_ring_r_0_null_null.72c9adf3.png";